import { trackPageLoad } from "@asosteam/asos-content-web-analytics";
import analyticsProvider from "./analyticsProvider";

export const trackPageEvent = async (props, extraProps = {}) => {
  try {
    const config = await analyticsProvider("page-load", props, extraProps);
    await trackPageLoad(config);
  } catch (e) {
    throw new Error(e);
  }
};
